import React from 'react';
import * as icons from '@boxine/tonies-ui/icons';
import styled from 'styled-components';
import { deprecate } from '../utils/deprecate';
import { theme } from '../themes/theme';
import { ProgressIndicator } from '../ProgressIndicator';
import { buttonStyle } from './components/StyledButton';
import StyledButtonText from './components/StyledButtonText';
import StyledIcon from './components/StyledIcon';
import StyledTextLink from './components/StyledTextLink';
import ButtonLink from './components/ButtonLink';
import { StyledProgressWrapper } from './components/StyledProgressWrapper';
const WrapButtonLink = styled(ButtonLink) `
  ${buttonStyle}
`;
const StyledButton = styled.button `
  ${buttonStyle}
`;
function StartIcon({ styling, iconStart, disabled = false }) {
    return (styling === 'primary' ||
        styling === 'secondary' ||
        styling === 'secondaryWhite') &&
        iconStart ? (React.createElement(StyledIcon, { type: iconStart, style: styling, fillAll: styling === 'primary'
            ? disabled
                ? theme.LightGray
                : theme.White
            : disabled
                ? theme.DirtyWhiteDarker
                : theme.BrandPrimary })) : null;
}
/**
 * @deprecated since version 61, please use Button instead
 */
export const OmniButton = deprecate((props) => {
    const { isBackLink = false, hideBackLinkTextOnMobile = true, isCoupon = false, children, className, dataTestId: dataTestIdDeprecated, 'data-testid': dataTestId, 'data-trackingid': dataTrackingId, iconStart, iconEnd, iconTitle = undefined, styling, formNoValidate, isWhiteTextLink = false, } = props;
    const textLinkContent = (React.createElement(React.Fragment, null,
        isBackLink && (React.createElement(StyledIcon, { "data-testid": "backLink-icon", backLink: isBackLink, fill: isWhiteTextLink ? theme.colors.white : theme.colors.primary, fillAll: isWhiteTextLink ? theme.colors.primary : '', title: iconTitle, type: icons.arrowLeftFill })),
        isCoupon && (React.createElement(StyledIcon, { "data-testid": "coupon-icon", 
            // FIXME
            start: icons.plusFill, fill: theme.colors['green-100'], title: iconTitle, type: icons.plusFill })),
        iconStart && (React.createElement(StyledIcon, { "data-testid": "start-icon", start: iconStart, fill: isWhiteTextLink ? theme.colors.white : theme.colors.primary, fillAll: isWhiteTextLink ? theme.colors.primary : '', title: iconTitle, type: iconStart })),
        React.createElement(StyledButtonText, { backLink: isBackLink, hideBackLinkTextOnMobile: hideBackLinkTextOnMobile, isCoupon: isCoupon, isWhiteTextLink: isWhiteTextLink, styling: styling }, children),
        iconEnd && (React.createElement(StyledIcon, { "data-testid": "end-icon", end: iconEnd, fill: isWhiteTextLink ? theme.colors.white : theme.colors.primary, fillAll: isWhiteTextLink ? theme.colors.primary : '', title: iconTitle, type: iconEnd }))));
    if ('href' in props) {
        const { href, target, rel } = props;
        return (React.createElement(WrapButtonLink, { styling: styling, href: href, "data-testid": dataTestId || dataTestIdDeprecated, "data-trackingid": dataTrackingId, className: className, target: target, rel: rel, formNoValidate: formNoValidate }, !styling || styling === 'secondaryTextlink' ? (React.createElement(StyledTextLink, { isCoupon: isCoupon, isWhiteTextLink: isWhiteTextLink, isBackLink: isBackLink }, textLinkContent)) : (React.createElement(React.Fragment, null,
            React.createElement(StartIcon, { styling: styling, iconStart: iconStart }),
            React.createElement("span", null, children)))));
    }
    else {
        const { isPending = false, disabled = false } = props;
        let onClick = undefined;
        let type = 'button';
        if ('type' in props) {
            type = props.type;
        }
        else {
            onClick = props.onClick;
        }
        return (React.createElement(StyledButton, { disabled: disabled || isPending, "data-disabled": disabled, styling: styling, onClick: onClick, "data-testid": dataTestId || dataTestIdDeprecated, "data-trackingid": dataTrackingId, className: className, isPending: isPending, type: type, formNoValidate: formNoValidate }, !styling || styling === 'secondaryTextlink' ? (React.createElement(StyledTextLink, { isCoupon: isCoupon, isWhiteTextLink: isWhiteTextLink, isBackLink: isBackLink }, textLinkContent)) : (React.createElement(React.Fragment, null,
            React.createElement(StartIcon, { styling: styling, iconStart: iconStart, disabled: disabled }),
            isPending && (React.createElement(StyledProgressWrapper, null,
                React.createElement(ProgressIndicator, { styling: styling === 'secondary' ||
                        styling === 'secondarySmall' ||
                        styling === 'secondaryWhite' ||
                        styling === 'secondarySmallWhite'
                        ? 'secondary'
                        : 'primary', width: "100%" }))),
            React.createElement("span", null, children)))));
    }
}, '<OmniButton /> is deprecated. Please use <Button /> instead');
